import { getAllServices } from '@/services/rc/repair-services.service'
import type { IService } from '@/types/rc/work-orders'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRepairServiceStore = defineStore('repair-services', () => {
  const repairServices = ref<IService[]>([])

  /**
   * Gets all available repair services.
   */
  const getRepairServices = async () => {
    repairServices.value = await getAllServices()
  }

  return {
    repairServices,
    getRepairServices,
  }
})
